module.exports = __webpack_public_path__ + "static/media/gallery7.38845b4c.jpg";